import { z } from 'zod';

/**
 * Item status scheduling type constants (string literals).
 */
export const ITEM_STATUS_SCHEDULING_TYPE = {
  IN_PROGRESS: 'IN_PROGRESS',
  TO_DO: 'TO_DO',
  DONE: 'DONE',
} as const;

/**
 * Zod schema for item status scheduling type enum.
 */
export const itemStatusSchedulingTypeSchema = z.enum(ITEM_STATUS_SCHEDULING_TYPE).nullable();

/**
 * Zod schema for item status domain model.
 *
 * This represents the domain model of an item status.
 */
export const itemStatusSchema = z.object({
  id: z.number().int().positive(),
  schedulingType: itemStatusSchedulingTypeSchema,
  name: z.string(),
  color: z.string(),
  priority: z.string(),
  isDefault: z.boolean(),
  archivedAt: z.number().int().optional(),
});

export type ItemStatusSchedulingType = z.infer<typeof itemStatusSchedulingTypeSchema>;
export type ItemStatusDTO = z.infer<typeof itemStatusSchema>;
